export default "__VITE_ASSET__1551b4e4__"